var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("EBN Check Exempt - Pickup")])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select Client")]), _vm._v(" "), _c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.Clientlist,
      "name": "Clientlist",
      "placeholder": "Select Clients",
      "label": "clientName",
      "track-by": "clientId",
      "multiple": true,
      "scroll": true
    },
    model: {
      value: (_vm.selectedClients),
      callback: function($$v) {
        _vm.selectedClients = $$v
      },
      expression: "selectedClients"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Clientlist')),
      expression: "errors.has('Clientlist')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select client name.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "cursor": "pointer",
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save"
    },
    on: {
      "click": _vm.saveClientEBNExemption
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72eedc41","hasScoped":true}!./src/modules/masterdata/views/ClientEBNExemptionConfig/saveebnexemption.component.html
// module id = 844
// module chunks = 3